import React, { useState, useEffect,useRef, useContext } from 'react';
import InvoiceApi from '../api/InvoiceApi';
import { FaPlusCircle } from 'react-icons/fa';
import { IoMdMail } from 'react-icons/io';
import { FaMoneyBillAlt } from 'react-icons/fa';
import InvoiceForm from './InvoiceForm';
import SettingApi from '../api/SettingApi';
import { ImCancelCircle } from 'react-icons/im';
import TransactionForm from '../transactions/TransactionForm';
import TransactionApi from '../api/TransactionApi';
import TransactionList from '../transactions/TransactionList';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { SettingsContext } from '../Context/SettingContext';

const InvoiceDetails = ({ refresh, invoiceData, onSubmits, msg, toogle }) => {
  const { settings  } = useContext(SettingsContext);
  const [details, setDetails] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [editInvoiceId, setEditInvoiceId] = useState(null);
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [totalPaidAmount, setTotalpaidAmount] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [showPayPal, setShowPayPal] = useState(false);

  useEffect(() => {
    if (details) {
      getTransactions(details.id);
    }
  }, [details]);
  
  
  useEffect(() => {
    if (invoiceData) {
      setDetails(invoiceData.data ? invoiceData.data : invoiceData);
      const selectedItemsData = JSON.parse(
        invoiceData.invoice_items_data
          ? invoiceData.invoice_items_data
          : invoiceData.item_data
      );
      setSelectedItems(selectedItemsData);
    }
  }, [invoiceData]);

  useEffect((dueAmounts) => {
      if(dueAmounts === 0){
            updateInvoice(invoiceData.id ? invoiceData.id : invoiceData.data.id, false);
          }
  },[invoiceData])

  const getTransactions = async (id) => {
    try {
      const res = await TransactionApi.invoiceDetails(id);
      if (res) {
        let paidAmounts = 0;
        res.map(item =>{ const amountPid = parseInt(item.amount)
          paidAmounts +=amountPid;
          setTotalpaidAmount(paidAmounts);
        })
        const totalAmouts = details.amount-details.discount;
        setTotalAmount(totalAmouts.toFixed(0));
      }

    } catch (error) {
      console.error('Error fetching transactions:', error);
    }
  };

  const updateInvoice = async (id, refresh = true) => {
    const res = await InvoiceApi.update({id: id, make_paid: true});
    if (res) {
      setMessage(res.message);
      onSubmits();
        toogle();
      setTimeout(() => {
        setMessage('');
     }, 2000);
    }
  };


  const sendMails = async (id) => {
    try {
      const res = await InvoiceApi.sendMails(id);
    } catch (error) {
      console.error("Error sending mail:", error);
    }
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const itemEdit = (id) => {
    setEditInvoiceId(id);
    setShowDetails(true);
  };

  const printInvoice = () => {
    window.print();
  };

  const copyLink = async (invoice_no) =>  {
    const link = `${settings.home_url}/${settings.invoice_page}/?inv=${invoice_no}`;
    const textarea = document.createElement("textarea");
    textarea.value = link;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    alert("Link copied to clipboard");
  };


  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const dueAmounts = totalAmount-totalPaidAmount;
  const handlePayPalClick = () => {
    setShowPayPal(prevState => !prevState);
  };


  return (
    <>
      {showModal ? (
        <>
          <div
            className="fixed justify-center items-center flex overflow-x-hidden overflow-y-auto inset-0 z-50 outline-none focus:outline-none"
          >
            <div className="relative w-auto my-6 mx-auto max-w-7xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col modal-width bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between rounded-t">
                  <a
                    className="d-none  mt-2 !ml-2 text-2xl text-gray-400 cursor-pointer"
                    onClick={() => setShowModal(false)}
                  >
                    <ImCancelCircle />
                  </a>
                </div>
                <div className="relative flex-auto">
                  <TransactionForm invoiceData={details} onSubmits={onSubmits} toogle={toogle}  paidAmount={totalPaidAmount} modal="true" />
                </div>
              </div>
            </div>
          </div>
          <div className="fixed opacity-25 inset-0 z-40 bg-black"></div>
        </>
      ) : null}
      {message && (
        <div
          className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3"
          role="alert"
        >
          <p className="font-bold">{message}</p>
        </div>
      )}
      {!showDetails ? (
        <div className="px-7 sm:px-6 lg:px-8 mx-auto pb-12">
          <div className="">
            <div className="grid grid-cols-4 py-5 d-none">
              <div className="">
                Status
                <br />
                {details.status === "Draft" ? (
                  <span className="inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-full text-xs font-medium bg-blue-600 text-white dark:bg-blue-500 text-center">
                    {details.status}
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-full text-xs font-medium bg-teal-500 text-white text-center">
                    {details.status}
                  </span>
                )}
              </div>
              <div className="">
                Customer
                <br />
                <b>{details.contact_name}</b>
              </div>
              <div className="">
                Amount
                <br />
                <b>${details.amount}</b>
              </div>
              <div className="">
                Due on
                <br />
                <b>{formatDate(details.due_at)}</b>
              </div>
            </div>
            <div className="d-none mt-3 mb-5 p-4 bg-white border rounded">
              <div className="grid grid-cols-3">
                <div className="mb-2">
                  <div className="mb-3 text-2xl">
                    <FaPlusCircle />
                  </div>
                  <div className="">
                    <h6>Edit {details.type}</h6>
                    <p>Status: Created on {formatDate(details.issued_at)}</p>
                    {dueAmounts > 0  && (
                    <a
                      onClick={(e) => {
                        itemEdit(details.id);
                      }}
                      className="cursor-pointer mt-1 mr-2 py-2 px-3 inline-flex justify-center items-center gap-2 rounded-lg border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm"
                    >
                      Edit
                    </a>
                    )}
                    <button
                      onClick={printInvoice}
                      className="mt-1 py-2 px-3 inline-flex justify-center items-center gap-2 rounded-lg border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm"
                    >
                      Print
                    </button>
                  </div>
                </div>
                <div className="">
                  <div className="mb-3 text-2xl">
                    <IoMdMail />
                  </div>
                  <div className="">
                    <h6>Send {details.type}</h6>
                    <p>Status: {details.status}</p>
                    <div className="row mt-2">
                      <button
                        onClick={(e) => sendMails(invoiceData.id ? invoiceData.id : invoiceData.data.id)}

                        className="py-2 px-3 inline-flex justify-center items-center gap-2 rounded-lg border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm"
                      >
                        Send Mail
                      </button>
                      <button
                        onClick={(e) => copyLink(details.invoice_no)}
                        
                        className="ml-2 py-2 px-3 inline-flex justify-center items-center gap-2 rounded-lg border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm"
                      >
                        Share
                      </button>
                    </div>
                  </div>
                </div>
                {details.status == 'paid' ? "" :
                <div className="">
                  <div className="mb-3 text-2xl">
                    <FaMoneyBillAlt />
                  </div>
                  <div className="">
                    <h6>Get Paid</h6>
                    <p>Status: Awaiting Payment</p>
                    <div className="row mt-2">
                      <div className="">
                     
                        <a
                          onClick={(e) => updateInvoice(invoiceData.id ? invoiceData.id : invoiceData.data.id)}
                          
                          className="cursor-pointer py-2 px-3 inline-flex justify-center items-center gap-2 rounded-lg border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm"
                        >
                          Mark Paid
                        </a>
                          {dueAmounts > 1 && (
                          <a
                            onClick={() => setShowModal(true)}
                            className="ml-2 cursor-pointer py-2 px-3 inline-flex justify-center items-center gap-2 rounded-lg border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm"
                          >
                            Add Payment
                          </a>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                     }
              </div>
            </div>
            <div className="flex flex-col p-4 sm:p-10 bg-white shadow-md rounded-xl print:-mt-25">
              <div className="flex justify-between">
                <div>
                  <h1 className="mt-2 text-lg md:text-xl font-semibold text-blue-600">
                    {settings.company_name}
                  </h1>
                  <p className="mt-2 text-md font-semibold">
                    {settings.address}
                  </p>
                  <p className="mt-2 text-md font-semibold">
                    {settings.phone}
                  </p>
                  <p className="mt-2 text-md font-semibold">
                  {details.type === 'bill' ? 'Bill' : 'Invoice'} <span> To:</span>
                  </p>
                  <p className="mt-2 text-md font-semibold">
                    {details.contact_name}
                  </p>
                    <p className="mt-2 text-md font-semibold">
                    {details.contact_email}
                    </p>
                </div>
                <div className="text-end">
                  <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
                    {details.invoice_no}
                  </h2>
                </div>
              </div>
              <div className="mt-8 grid grid-cols-2 gap-3">
                <div></div>
                <div className="text-end space-y-2">
                  <div className="grid grid-cols-1 gap-3 ">
                    <dl className="grid grid-cols-2 gap-x-3">
                      <dt className="font-semibold text-gray-800">{details.type === 'bill' ? 'Bill' : 'Invoice'} <span> date:</span></dt>
                      <dd className="text-gray-500">{formatDate(details.issued_at)}</dd>
                    </dl>
                    <dl className="grid grid-cols-2 gap-x-3">
                      <dt className="font-semibold text-gray-800">Due date:</dt>
                      <dd className="text-gray-500">{formatDate(details.due_at)}</dd>
                    </dl>
                  </div>
                </div>
              </div>
              <div className="mt-6">
                <div className="border border-gray-200 p-4 rounded-lg space-y-4">
                  <div className="grid grid-cols-4">
                    <div className="sm:col-span-2 text-xs font-medium text-gray-500 uppercase">
                      Item
                    </div>
                    <div className="text-start text-xs font-medium text-gray-500 uppercase">
                      Qty
                    </div>
                    <div className="text-end text-xs font-medium text-gray-500 uppercase">
                      Rate
                    </div>
                  </div>
                  <div className="block border-b border-gray-200"></div>
                  {selectedItems.map((item) => (
                    <div className="grid grid-cols-4 gap-2" key={item.id}>
                      <div className="col-span-2">
                        <h5 className="sm:hidden text-xs font-medium text-gray-500 uppercase">Item</h5>
                        <p className="font-medium text-gray-800">{item.name}</p>
                      </div>
                      <div>
                        <h5 className="sm:hidden text-xs font-medium text-gray-500 uppercase">
                          Qty
                        </h5>
                        <p className="text-gray-800">{item.quantity}</p>
                      </div>
                      <div>
                        <h5 className="sm:hidden text-xs font-medium text-gray-500 uppercase">
                          Rate
                        </h5>
                        <p className="text-gray-800 text-end">${details.type === 'bill' ? item.purchase_price : item.sale_price}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-5 flex flex-col sm:justify-end">
                  <div className="space-y-2">
                  <div className="grid gap-4">
                  <div className="grid sm:grid-cols-5 gap-x-3 text-end">
                  <div className="col-span-3 font-semibold text-gray-800">Subtotal:</div>
                  <div className="col-span-2 text-gray-500">${details.amount}</div>
                  </div>
                  {details.discount && !isNaN(details.discount) ? (
                  <div className="grid sm:grid-cols-5 gap-x-3 text-end">
                  <dt className="col-span-3 font-semibold text-gray-800">Discount:</dt>
                  <dd className="col-span-2 text-gray-500">${Number(details.discount).toFixed(0)}</dd>
                  </div>
                  ) : ''}
                  <div className="grid sm:grid-cols-5 gap-x-3 text-end">
                  <div className="col-span-3 font-semibold text-gray-800">Total:</div>
                  <div className="col-span-2 text-gray-500">${totalAmount}</div>
                  </div>
                  {totalPaidAmount ?
                  <div className="grid sm:grid-cols-5 gap-x-3 text-end">
                  <div className="col-span-3 font-semibold text-gray-800">paid Amount:</div>
                  <div className="col-span-2 text-gray-500">${totalPaidAmount}</div>
                  </div> : ''}

                  <div className="grid sm:grid-cols-5 gap-x-3 text-end">
                  <div className="col-span-3 font-semibold text-gray-800">Dues:</div>
                  <div className="col-span-2 text-gray-500">${dueAmounts}</div>
                  </div>

                  </div>
                  </div>

                  {/* PayPal  */}
                  <div className='flex justify-end'>
                  {
                  dueAmounts > 0 && <button className='bg-gray-600 text-white px-4 py-1.5 rounded-md my-4 print:hidden' onClick={handlePayPalClick}>Pay With PayPal</button>
                  }
                  </div>
                  {/* Payment Gateway */}
                  <div className='h-[60px] flex justify-end w-full'>
                  {(showPayPal && Number(dueAmounts) > 0)  ? (
                    <PayPalScriptProvider options={{ "client-id": settings?.paypal_client_id, components: "buttons", dataNamespace: "paypal_sdk" }}>
                        <PayPalButtons style={{ layout: "vertical" }}
                                      fundingSource="paypal"
                                      disableFunding="paylater" 
                                      createOrder={(data, actions) => {
                                          
                                              return actions.order.create({
                                                  purchase_units: [
                                                      { amount: { currency_code: "USD", value: dueAmounts }, invoice_id: invoiceData.invoice_id }
                                                  ],
                                              });
                                          }}

                                          onApprove={async (data, actions) => {
                                            return actions.order.capture().then(async (details) => {
                                                try {
                                                    const paymentData = {
                                                        amount: dueAmounts,
                                                        type: "income",
                                                        id: invoiceData.id,
                                                        document_id: invoiceData.id,
                                                        contact_id : invoiceData.contact_id,
                                                        category_id : invoiceData.category_id,
                                                        payment_method: "PayPal",
                                                        reference: JSON.stringify(details),
                                                        paid_at: details.update_time,
                                                    };
                                                    const res = await TransactionApi.save(paymentData);
                                                    updateInvoice(invoiceData.id)
                                                    if (res.success) {
                                                        getTransactions(invoiceData.id);
                                                      
                                                    } else {
                                                        console.error("API Error:", res);
                                                    }
                                                } catch (error) {
                                                    console.error("Error processing payment:", error);
                                                }
                                            });
                                        }}
                                        
                                      onError={(err) => {
                                          console.error("PayPal error:", err);
                                          
                                      }}
                          />
                    </PayPalScriptProvider>
                    
                  ) : ''}

                  </div>
              </div>
            </div>
        
            <div className="d-none mt-6 pb-8">
              {/* Button to toggle collapsible section */}
              <button
                className="text-blue-600 hover:text-blue-800"
                onClick={toggleCollapse}
              >
                {isCollapsed ? "Show Transaction List" : "Hide Transaction List"}
              </button>
              {!isCollapsed && (
                <div className="mt-3">
                  {details && (
                    <TransactionList
                      invoiceData={details}
                      invoices="true"
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="d-none">
          <InvoiceForm onSubmits={onSubmits} invoiceId={editInvoiceId} />
        </div>
      )}
    </>
  );
};

export default InvoiceDetails;
